import React, { Fragment, useContext } from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import AuthContext from "Context/Auth/AuthContext";
import { Color } from "Styles/Theme";
import logo from "../../Images/fixo_ko2.png";
import { device } from "Styles/Media";

const Header = ({ history: { push } }) => {
  const authContext = useContext(AuthContext);
  const { isAuthenticated, logout, user } = authContext;

  const onLogout = () => {
    logout();
    push("/");
  };

  const authLinks = (
    <Fragment>
      <EnrollButton to="/corrector-register">첨삭자등록</EnrollButton>
      <CorrectionListButton to="/editlist">첨삭리스트</CorrectionListButton>
      <UserButton>
        <img src={user} alt="user-profile" />
        <List>
          <ul>
            <li onClick={onLogout}>로그아웃</li>
          </ul>
        </List>
      </UserButton>
    </Fragment>
  );

  const guestLinks = (
    <Fragment>
      <EnrollButton to="/corrector-register">첨삭자등록</EnrollButton>
      <LoginButton to="/login">로그인</LoginButton>
    </Fragment>
  );

  return (
    <Container>
      <div>
        <Link to="/">
          <Logo src={logo} alt="Fixo" />
        </Link>
        <Nav>{isAuthenticated ? authLinks : guestLinks}</Nav>
      </div>
    </Container>
  );
};

export default withRouter(Header);

const Container = styled.div`
  height: 90px;
  color: #7903d4;
  border-bottom: 1px solid #ddd;

  & > div {
    max-width: 1200px;
    height: 100%;
    margin: 0px auto;
    padding: 0px 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const Logo = styled.img`
  width: 92px;
`;

const Nav = styled.nav`
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 16px;
  color: ${Color.black};
  position: relative;
  @media ${device.mobile} {
    font-size: 14px;
  }
`;

const LinkButton = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const LoginButton = styled(LinkButton)``;

const EnrollButton = styled(LinkButton)`
  margin-right: 30px;
  @media ${device.mobile} {
    margin-right: 14px;
  }
`;

const CorrectionListButton = styled(LinkButton)`
  margin-right: 30px;
  @media ${device.mobile} {
    margin-right: 12px;
  }
`;

const List = styled.div`
  display: none;
  position: absolute;
  padding: 6px 0;
  top: 80px;
  right: 0px;
  background-color: #fff;
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
  z-index: 9;

  li {
    cursor: pointer;
    width: 140px;
    padding: 16px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    transition: background-color 0.1s linear;
    &:hover {
      background-color: #eee;
    }
  }
`;

const UserButton = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  img {
    display: block;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    @media ${device.mobile} {
      width: 34px;
      height: 34px;
    }
  }

  &:hover ${List} {
    display: block;
  }
`;
